export default function GoogleRating({ google }) {
	return (
		<div className="dashboard-card">
			<div className="card-head">
				<div>
					<p className="panel-overline">Réputation</p>
					<h3>Note Google</h3>
				</div>
				<span className="badge">{google.badge}</span>
			</div>
			<div className="google-note">
				<span className="note">{google.note}</span>
				<span className="reviews">{google.total}</span>
			</div>
		</div>
	);
}
